import { ResponseStatus, StatusMessage } from '../services/rest-service.service';

const findInnerMessage = (status: StatusMessage): StatusMessage => {
  if (status.inner) {
    return findInnerMessage(status.inner);
  } else {
    return status;
  }
};

export const parseError = (error, data): ResponseStatus<any> => {
  const errorMsg: ResponseStatus<any> = {
    data,
    statusNumber: 500,
    nextTaskDetails: null,
    ...error
  } as any;

  if (error.status && error.error) {
    const status: StatusMessage = error.error.statusMessage;
    errorMsg.statusNumber = error.error.statusNumber;
    errorMsg.error.statusMessage.message = status && status.inner ? findInnerMessage(status.inner).message : status.message;
  } else {
    if (errorMsg.error && errorMsg.error.statusMessage) {
      errorMsg.error.statusMessage.message = 'Something went wrong!';
    } else {
      errorMsg.error = {
        ...errorMsg.error,
        statusMessage: {
          message: 'Something went wrong!'
        }
      };
    }
  }

  return errorMsg;
};
export const parseMessage = (message: string = '', code: string) => {
  try {
    const parts = message.split(':');
    if (parts.length) {
      const [title, errors] = parts;

      if (!errors || (errors && errors.length === 0)) {
        return {
          title: code,
          errorList: [title]
        };
      }
      const errorList = errors.split(/[\.\!]+(?!\d)\s*|\n+\s*/).filter(err => !!err);
      return {
        title: title || '',
        errorList
      };
    }
    return {
      title: message,
      errorList: []
    };
  } catch (error) {
    return {
      title: message,
      errorList: []
    };
  }
};
